import { ProjectTypeEnum, ProjectStatusEnum, ProjectStageEnum } from "../../../../../../consts/projectTypeOptions"

export const normalizeProjectType = (value: string | null | undefined): ProjectTypeEnum =>
    Object.values(ProjectTypeEnum).includes(value as ProjectTypeEnum)
        ? (value as ProjectTypeEnum)
        : ProjectTypeEnum.ONE_TIME
  
export const normalizeProjectStatus = (value: string | null | undefined): ProjectStatusEnum =>
    Object.values(ProjectStatusEnum).includes(value as ProjectStatusEnum)
        ? (value as ProjectStatusEnum)
        : ProjectStatusEnum.DRAFT

export const normalizeProjectStage = (value: string | null | undefined): ProjectStageEnum =>
    Object.values(ProjectStageEnum).includes(value as ProjectStageEnum)
        ? (value as ProjectStageEnum)
        : ProjectStageEnum.IDEA